var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('h1',[_vm._v("Security")])])],1),_c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('p',[_vm._v("Account security and recommendations")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }